// API base URL, read from REACT_APP_BACKEND_URL — no hard-coded fallback
// (issue #29 / M1.6). A missing value fails loudly instead of silently
// defaulting to a production backend.
export const getApiBaseUrl = (): string => {
  const url = process.env.REACT_APP_BACKEND_URL;
  if (!url) {
    throw new Error(
      'REACT_APP_BACKEND_URL is not set. Set it in your environment (e.g. .env.local for local development) — there is no hard-coded fallback.',
    );
  }
  return url;
};

export const API_CONFIG = {
  baseURL: getApiBaseUrl(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
};

// CORS configuration for production
export const CORS_OPTIONS = {
  origin: process.env.NODE_ENV === 'production' 
    ? ['https://your-frontend-domain.vercel.app'] 
    : ['http://localhost:3000'],
  credentials: true,
  methods: ['GET', 'POST', 'PUT', 'DELETE', 'OPTIONS'],
  allowedHeaders: ['Content-Type', 'Authorization', 'x-device-id', 'x-correlation-id']
}; 